module.exports = __webpack_public_path__ + "static/media/run.20960ba5.png";